import {styled} from '@innowise-group/ui-kit';

export const AuthContainer = styled.section`
  display: flex;
  height: 100%;
`;
